import { normalizeSlideThemeVars } from "@/pages/how-to-start/utils/normalize-slide-theme-vars";

// Same slot repair the funnel runs on generated slides; the helper mutates, so
// the fetched result the manager keeps is never touched.
export const normalizeOptionSlide = (slide: unknown): unknown =>
  slide && typeof slide === "object"
    ? normalizeSlideThemeVars(structuredClone(slide))
    : slide;
